export default {
  // updateAuthorizationUrl (state, payload) {
  //   state.authorizationUrl = payload
  // }
  menuList (state, payload) {
    state.menuList = payload
  },
  detectionPackageList (state, payload) {
    state.detectionPackageList = payload
  },
  goodsTypeList (state, payload) {
    state.goodsTypeList = payload
  }
}
